/**
 * Show Formatter.
 */
window.showFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<a href="'+value+'" class="action-show">';
        html += '<i class="fontawesome fas fa-eye"></i>';
        html += '</a>';
    }
    return html;
}
